
import { defineComponent } from 'vue'

const TABS = [
    { id: 'general', name: 'Общая информация' },
    { id: 'cargo', name: 'Характеристики груза' },
    { id: 'courier', name: 'Данные водителя и ТС' },
    { id: 'payment', name: 'Оплата' }
]

export default defineComponent({
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    emits: ['update:value', 'change'],
    setup(props, { emit }) {
        const isTabSelected = (tab: { id: string }) => {
            if (!props.value) return false
            return props.value === tab.id
        }

        const selectTab = (tab: { id: string }) => {
            if (isTabSelected(tab)) return
            emit('update:value', tab.id)
            emit('change', tab.id)
        }

        return {
            TABS,
            isTabSelected,
            selectTab,
        }
    },
})
